import useQueries from '../../useQueries';

/**
 * Who supports each of a design's groups, keyed by group, for several designs.
 *
 * One request per design rather than one for the account: a design is what the
 * route answers for, so a write to one group invalidates that design's key and
 * leaves the others cached.
 *
 * @param {String[]} designIds
 * @returns {Array}
 */
export default function useDesignsSupporters(designIds = []) {
  return useQueries(
    designIds.map((designId) => {
      const path = `v1/designs/${designId}/supporters`;

      async function getSupporters() {
        return await this.get(path);
      }

      return { path, fetcher: getSupporters };
    }),
    {
      staleTime: 5 * 60 * 1000, // 5m
    }
  );
}
